import React from "react";

export default function SeasonSelect({ seasons, value, onChange }) {
  if (!seasons || seasons.length === 0) {
    return null;
  }

  return (
    <label className="nfl-select">
      <span className="nfl-select-label" aria-hidden="true">
        Season
      </span>
      <select
        aria-label="Season"
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
      >
        {seasons.map((season) => (
          <option key={season.id} value={season.year}>
            {season.year}
          </option>
        ))}
      </select>
    </label>
  );
}
